import { TECHNICAL_ERROR_MESSAGE } from 'fixtures/constants';

export default function buildFetchSearchResultsFailedPayload(error = {}, { resultSetId } = {}) {
	const response = error.response || {};

	return {
		...(resultSetId ? { resultSetId } : {}),
		errors:
			!response?.apiErrors?.length && !response?.supplierErrors?.length
				? [TECHNICAL_ERROR_MESSAGE]
				: [],
		apiErrors: response?.apiErrors || [],
		supplierErrors: response?.supplierErrors || [],
	};
}
